import { HSOverlay, HSStaticMethods } from "preline";
import { Component } from "../../../types";
import { cleanUpAllChildren, initAllComponents } from "../../lib/initAllComponents";
import { router } from "../../router";

type IsImportProcessSuccess = (isImportProcessRunning: boolean | null) => void;
const platformsNameArr: { [key: string]: string } = {
    "GoogleReviews": "Google",
    "YoutubeComments": "YouTube Comments",
    "PlaystoreReviews": "Google Play Store",
    "ProductHuntReviews": "PH Review",
    "ProductHuntComments": "PH Comments",
    "CourseraReview": "Coursera",
    "HealmeReviews": "Heal.me",
    "ItalkiReviews": "Italki",
    "OYOReviews": "OYO",
    "SkillshareReviews": "Skillshare",
    "PeoplePerHourReviews": "People Per Hour",
    "ApplePodcastReviews": "Apple Podcast",
    "ZomatoReviews": "Zomato",
    "UdemyReviews": "Udemy",
    "FreshaReviews": "Fresha",
    "AppStoreReviews": "App Store",
    "HomeStarsReviews": "HomeStars",
    "GoodreadsReviews": "Goodreads",
    "ThemeForestReviews": "ThemeForest Reviews",
    "RottenTomatoesReviews": "Rotten Tomatoes",
    "RealtorReviews": "realtor.com",
    "GumroadReviews": "Gumroad",
    "IMDbReviews": "IMDb",
    "TrustpilotReviews": "Trustpilot",
    "BookingComAttractionReviews": "Booking.com Attraction",
    "AppSumoReviews": "AppSumo",
    "TripadvisorReviews": "Tripadvisor",
    "wordpressPluginReviews": "WordPress Plugins",
    "BookingReviews": "Booking.com Reviews",
    "AmazonProduct": "Amazon Product",
    "ebay": "ebay",
    "Fiverr": "Fiverr",
    "Indeed": "Indeed",
    "LinkedIn": "LinkedIn Recommendation",
    "Flipkart": "Flipkart",
    "Swiggy": "Swiggy",
    "Expedia": "Expedia",
    "G2": "G2",
    "hotels": "hotels.com",
    "figma": "Figma plugin Comments",
    "medium-comments": "Medium Comments",
    "ChromeExtension": "Chrome extension",
    "Whop": "Whop",
    "Sourceforge": "Sourceforge",
    "Zillow": "Zillow",
    "Glassdoor": "Glassdoor",
    "Upwork": "Upwork",
    "Freelancer": "Freelancer",
    "Capterra": "Capterra",
    "Clutch": "Clutch",
    "Yelp": "Yelp",
    "abia": "ABIA Wedding",
    "agoda": "agoda",
    "Angi": "Angi",
    "ClassPass": "classpass",
    "EasyWeddings": "Easy Weddings",
    "Foursquare": "Foursquare",
    "OpenTable": "OpenTable",
    "RateMDs": "RateMDs",
    "ShopifyAppStore": "Shopify App Store",
    "ShopifyPartners": "Shopify Partners",
    "ShopifyTheme": "Shopify Theme",
    "Twitter": "Twitter",
    "Youtube": "Youtube",
    "VimeoVideo": "Vimeo Video",
    "Instagram": "Instagram",
    "BetterBusinessBureau": "Better Business Bureau",
    "Trip": "Trip.com",
    "Avvo": "Avvo",
    "TrustRadius": "TrustRadius",
    "YellowPages": "Yellow Pages", 
    "Influenster": "Influenster",
    "MerchantCircle": "MerchantCircle",
    "ConsumerAffair": "ConsumerAffairs",
    "Apartments": "Apartments",
    "EdMuds": "EdMuds",
    "FindLaw": "FindLaw",
    "WebMD": "WebMD",
    "Thumbtack": "Thumbtack",
    "Houzz": "Houzz",
    "HomeAdvisor": "Home Advisor",
    "Googleshopping": "Google shopping",
    "VRBO": "VRBO",
    "ZOCDOC": "ZOCDOC",
    "GreatSchools": "GreatSchools",
    "DealerRater": "DealerRater",
    "CustomerLobby": "Customer Lobby",
    "CusRev": "CusRev",
    "CreditKarma": "Credit Karma",
    "Checkatrade": "Checkatrade",
    "Cars": "cars.com",
    "CarGurus": "CarGurus",
    "Bilbayt": "Bilbayt",
    "AliExpress": "AliExpress",
    "AirbnbReviews": "Airbnb",
    "ThemeForestComments": "ThemeForest Comments"
};
  

export const ImportsModalCtx = {
    importsModal: null as Component | null,
    rendered: false,
    modalElem: null as HTMLElement | null,
    isImportProcessRunning: false,
    isImportProcessSuccess: false,
    subscribers: [] as IsImportProcessSuccess[],
    errorMessage: "Please double check your URL, looks like it's wrong or chat with support team now" as string, // error message

    // save the Imports Modal component instance
    setImportsModal(importsModal: Component) {
        this.importsModal = importsModal
    },

    // render the Imports Modal in the DOM and initiate it
    addImportsModalDOM() {
        if (this.importsModal) {
            document.body.insertAdjacentHTML("beforeend", this.importsModal.render());
            HSStaticMethods.autoInit()
            if (this.importsModal) {
                initAllComponents(this.importsModal)
            }
            this.rendered = true
            
        } else {
            console.error("You are trying to render the Imports Modal component before saving it's instance!");
        }
    },

    // remove the Imports Modal from the DOM and clean up
    removeImportsModalDOM() {
        const $modalElem = document.querySelector("#import-modal") as HTMLElement;
        const $quitModalElem = document.getElementById("import-quit-modal");
        const $importModalHiddenTrigger = document.getElementById("import-modal-hidden-trigger");
        if ($modalElem) {
            if (this.importsModal) cleanUpAllChildren(this.importsModal)
            $modalElem.remove();
            if ($quitModalElem) $quitModalElem.remove(); // also remove the quit model
            if ($importModalHiddenTrigger) $importModalHiddenTrigger.remove(); // also remove the quit model
            this.rendered = false;
        }
    },

    // Add a subscriber
    subscribe(callback: IsImportProcessSuccess) {
        this.subscribers.push(callback);
        // Return an unsubscribe function
        return () => {
            this.unsubscribe(callback);
        };
    },

    // Remove a subscriber
    unsubscribe(callback: IsImportProcessSuccess) {
        this.subscribers = this.subscribers.filter(sub => sub !== callback);
    },

    // Notify all subscribers
    notifySubscribers() {
        this.subscribers.forEach(callback => callback(this.isImportProcessSuccess));
    },

    setIsImportProcessSuccess(isImportProcessSuccess: boolean) {
        this.isImportProcessSuccess = isImportProcessSuccess;
        this.notifySubscribers();
    },

    setImportProcessRunning(isRunning: boolean) {
        this.isImportProcessRunning = isRunning;
    },

    getImportProcessRunning() {
        return this.isImportProcessRunning;
    },

    closeImportsModal() {
        this.setImportProcessRunning(false);
        this.modalElem = document.getElementById("import-modal");
        if (this.modalElem)
            HSOverlay.close(this.modalElem);
        setTimeout(() => {
            // this timeout ensures that ImportModal and QuitImportModal's backdrops 
            // are removed and properly closed before removing them from the DOM
            this.removeImportsModalDOM()
        }, 500); 
    },

    showErrorImage(element: HTMLElement,isSuccess: boolean = false, isError: boolean = true) {
        const tabPanelParent = element!.closest('[role="tabpanel"]');
        if (!tabPanelParent) return;
    
        const errorImage = tabPanelParent.querySelector<HTMLImageElement>('.import-feed-error-image');
        const infoImage = tabPanelParent.querySelector<HTMLImageElement>('.import-feed-info-image');
        const successImage = tabPanelParent.querySelector<HTMLImageElement>('.import-feed-success-image');
        const importCreaewolPageBtn = tabPanelParent.querySelector<HTMLDivElement>('.import-feed-create-wol-page-btn');
        const commonInfoMessage = tabPanelParent.querySelector<HTMLImageElement>('.platform-common-info-box');
        const successInfoMessage = tabPanelParent.querySelector<HTMLImageElement>('.platform-other-info-box');
        let platform = tabPanelParent.getAttribute("data-platform");
        const platformName = platformsNameArr[platform!];

        platform = platformName !== undefined ? platformName : platform;
    
        if (isError) {

            if(importCreaewolPageBtn && !importCreaewolPageBtn.classList.contains('hidden')) {
                importCreaewolPageBtn.classList.add('hidden');
            }

            if (errorImage && errorImage.classList.contains('hidden')) {
                errorImage.classList.remove('hidden');
            }
            if (infoImage && !infoImage.classList.contains('hidden')) {
                infoImage.classList.add('hidden');
            }
            if (successImage && !successImage.classList.contains('hidden')) {
                successImage.classList.add('hidden');
            }
            if (commonInfoMessage) {
                commonInfoMessage.classList.add('hidden');
            }
            if (successInfoMessage) {
                successInfoMessage.innerText = this.errorMessage;
                successInfoMessage.classList.remove('hidden');
            }
        } else if (isSuccess){
            if (successImage && successImage.classList.contains('hidden')) {
                successImage.classList.remove('hidden');
            }
            if (infoImage && !infoImage.classList.contains('hidden')) {
                infoImage.classList.add('hidden');
            }
            if (errorImage && !errorImage.classList.contains('hidden')) {
                errorImage.classList.add('hidden');
            }

            if (importCreaewolPageBtn && importCreaewolPageBtn.classList.contains('hidden')) {
                importCreaewolPageBtn.classList.remove('hidden');
                importCreaewolPageBtn.addEventListener('click', () => {
                    const $importModal = document.getElementById("import-modal");
                    if ($importModal) {
                        HSOverlay.close($importModal);
                    }
            
                    router.navigate("/pages", {
                        callHandler: true,
                    });

                    setTimeout(() => {
                        let $createPageBtn = document.querySelector('.page-name-modal') as HTMLButtonElement;
                        if($createPageBtn){
                            $createPageBtn.click();
                        }
                    }, 200);
                });
            }
            
            if (commonInfoMessage) {
                commonInfoMessage.classList.add('hidden');
            }
            if (successInfoMessage) {
                successInfoMessage.innerText = `Congrats! 🙌 You have successfully imported reviews from ${platform}. You can now create Wall of Love page to showcase good reviews to your potential customers or embed those reviews to your website. Click below to create wall of love.`;
                successInfoMessage.classList.remove('hidden');
            }
        } else {

            if(importCreaewolPageBtn && !importCreaewolPageBtn.classList.contains('hidden')) {
                importCreaewolPageBtn.classList.add('hidden');
            }
            
            if (errorImage && !errorImage.classList.contains('hidden')) {
                errorImage.classList.add('hidden');
            }

            if (successImage && !successImage.classList.contains('hidden')) {
                successImage.classList.add('hidden');
            }

            if (infoImage && infoImage.classList.contains('hidden')) {
                infoImage.classList.remove('hidden');
            }

            if (commonInfoMessage) {
                commonInfoMessage.classList.remove('hidden');
            }
            if (successInfoMessage) {
                successInfoMessage.classList.add('hidden');
            }
        }
    }
}